import Enums from 'utils/EnumsManager';

const { META_DATA } = Enums.REDUX_ACTION_TYPE_PREFIX;
const PREFIX = 'REPORTS';

export const ADD_DATA = `${META_DATA}_${PREFIX}_ADD_DATA`;
export const ADD_OR_UPDATE_DATA = `${META_DATA}_${PREFIX}_ADD_OR_UPDATE_DATA`;
export const RESET_REPORTS = `${META_DATA}_${PREFIX}_RESET_REPORTS`;



// WEBPACK FOOTER //
// ./src/store/metaData/reports/actionTypes.js